<template>
    <common-content-spacer class="insurance-auth" height="large">
        <common-page-header
            :isCenter="true"
            :heading="$t('pages.referrals.show.insurance_auth_status.status_updated')"
        ></common-page-header>

        <div class="insurance-auth__status">
            <common-icon :name="iconName" size="ultra-large"></common-icon>
            <div>{{ authorizationStatus }}</div>
        </div>

        <div class="insurance-auth__message">
            {{ message }}
        </div>
    </common-content-spacer>
</template>

<script>
    export default {
        props: {
            message: { type: String, default: null },
            isObtained: { type: Boolean, required: true },
        },

        computed: {
            iconName() {
                return this.isObtained ? 'success' : 'error'
            },

            authorizationStatus() {
                return this.isObtained
                    ? this.$t('pages.referrals.show.insurance_auth_status.authorization_obtained')
                    : this.$t('pages.referrals.show.insurance_auth_status.authorization_declined')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .insurance-auth {
        text-align: center;
        color: #333;

        &__status {
            font-weight: 500;
            font-size: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            div {
                margin-left: 10px;
            }
        }

        &__message {
            font-size: 18px;
        }
    }
</style>
